import Box from '@mui/material/Box';

import { AppTypography } from '~components/ui/typography/app-typography';

import { SidebarRouteType } from '../lessor-sidebar-routes';

import { SidebarItem } from './sidebar-item';

type Props = {
  title: string;
  items: SidebarRouteType[];
};

export const SidebarGroup = ({ title, items }: Props) => (
  <Box mt={0.75}>
    <AppTypography size="body-sm" color={'fog.65'} mb={1}>
      {title}
    </AppTypography>

    <Box display="flex" flexDirection="column" gap={0.5}>
      {items.map((item) =>
        item.route ? (
          <SidebarItem
            key={item.label}
            to={item.route}
            label={item.label}
            icon={item.icon}
          />
        ) : null
      )}
    </Box>
  </Box>
);
